/**
 * 判断PC端浏览器及其版本
 * @author yangyu
 */

const isServer = typeof window === 'undefined'

export function IEVersion () {
  if (isServer) return 0
  var userAgent = navigator.userAgent // 取得浏览器的userAgent字符串
  var isIE = userAgent.indexOf('compatible') > -1 && userAgent.indexOf('MSIE') > -1 // 判断是否IE<11浏览器
  var isEdge = userAgent.indexOf('Edge') > -1 && !isIE // 判断是否IE的Edge浏览器
  var isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf('rv:11.0') > -1
  if (isIE) {
    var reIE = new RegExp('MSIE (\\d+\\.\\d+);')
    reIE.test(userAgent)
    var fIEVersion = parseFloat(RegExp['$1'])
    if (fIEVersion === 7) {
      return 7
    } else if (fIEVersion === 8) {
      return 8
    } else if (fIEVersion === 9) {
      return 9
    } else if (fIEVersion === 10) {
      return 10
    } else {
      return 6 // IE版本<=7
    }
  } else if (isEdge) {
    let match = userAgent.match(/Edge\/(.+)$/)
    if (match && match.length > 1) return `Edge/${match[1]}`// edge
    else return -1
  } else if (isIE11) {
    return 11 // IE11
  } else {
    return -1 // 不是ie浏览器
  }
}

export function isIE () {
  if (isServer) return false
  let ieVersion = IEVersion()
  if (ieVersion !== -1) {
    if (isNaN(ieVersion)) return ieVersion
    else return `IE/${ieVersion}`
  }
  return false
}

// 360主页下才有效 不老实
export function is360 () {
  if (isServer) return false
  let userAgent = navigator.userAgent
  if (userAgent.indexOf('QIHU 360EE') !== -1) {
    return '360极速'
  }
  if (userAgent.indexOf('QIHU 360SE') !== -1) {
    return '360安全'
  }
  // 通过MimeType判断
  let mimeTypes = navigator.mimeTypes
  for (let i = 0; i < mimeTypes.length; ++i) {
    let mime = mimeTypes[i]
    if (mime.type.indexOf('360') !== -1) {
      let ie = isIE()
      if (ie) return `360兼容模式/${ie}`
      return '360极速模式'
    }
  }
  return false
}

// 判断是否为QQ浏览器
export function isQQ () {
  if (isServer) return false
  let userAgent = navigator.userAgent
  // 兼容模式
  let match = userAgent.match(/QQBrowser\/(.+)/)
  let ie = isIE()
  if (match && match.length > 1 && ie) return `QQ兼容模式/${ie}`
  // 极速模式
  match = navigator.userAgent.match(/QQBrowser\/(.+)$/)
  if (match && match.length > 1) return `QQ/${match[1]}`
  return false
}

// 判断是否为搜狗浏览器
export function isSougou () {
  if (isServer) return false
  let userAgent = navigator.userAgent
  // 兼容模式
  let match = userAgent.match(/SE\s+(.+)MetaSr\s+(.+)/)
  let ie = isIE()
  if (match && ie) {
    return `搜狗兼容模式/${ie}`
  }
  // 极速模式
  match = userAgent.match(/SE\s+(.+)\s+MetaSr\s+(.+)$/)
  if (match && match.length >= 3) {
    return `搜狗/${match[1]}`
  }
  return false
}

// 判断是否为谷歌浏览器
export function isChrome () {
  if (isServer) return false
  let userAgent = navigator.userAgent
  let vendor = navigator.vendor
  let match = userAgent.match(/Chrome\/(.+) Safari\/.+$/)
  if (match && match.length > 1 && /^Google/.test(vendor) && !isOpera() && !isSougou() && !isQQ() && !isBaidu() && !isMaxthon() && !isTheWorld()) {
    return `Chrome/${match[1]}`
  }
  return false
}

// 判断是否为火狐浏览器
export function isFirefox () {
  if (isServer) return false
  let userAgent = navigator.userAgent
  let match = userAgent.match(/Firefox\/(.+)$/)
  if (match && match.length > 1) {
    return `Firefox/${match[1]}`
  }
  return false
}

// 判断是否为Safari浏览器
export function isSafari () {
  if (isServer) return false
  let userAgent = navigator.userAgent
  let vendor = navigator.vendor
  let match = userAgent.match(/Safari\/(.+)$/)
  if (match && match.length > 0 && /^Apple Computer/.test(vendor)) {
    return `Safari/${match[1]}`
  }
  return false
}

// 判断是否为Opera浏览器
export function isOpera () {
  if (isServer) return false
  let userAgent = navigator.userAgent
  let match = userAgent.match(/OPR\/(.+)$/)
  if (match && match.length > 0) {
    return `Opera/${match[1]}`
  }
  // 兼容可能的老版本
  if (window.opr) {
    return 'Opera'
  }
  match = userAgent.match(/Opear/)
  if (match) return 'Opera'
  return false
}

// 判断是否为UC浏览器
export function isUC () {
  if (isServer) return false
  let userAgent = navigator.userAgent
  // 兼容模式
  let match = userAgent.match(/UBrowser\/(.+)\)/)
  let ie = isIE()
  if (match && ie) return `UC兼容模式/${match[1]}/${ie}`
  // 极速模式
  match = userAgent.match(/UBrowser\/(.+) Safari\/.+$/)
  if (match && match.length > 0) return `UC/${match[1]}`
  return false
}

// 判断是否为百度浏览器
export function isBaidu () {
  if (isServer) return false
  let userAgent = navigator.userAgent
  // 兼容模式 打不开控制台
  let match = userAgent.match(/BIDUBrowser\/(.+)$/)
  let ie = isIE()
  if (match && ie) return `百度兼容模式/${ie}`
  // 极速模式
  match = userAgent.match(/BIDUBrowser\/(.+) Safari\/.+$/)
  if (match && match.length > 0) return `百度/${match[1]}`
  return false
}

// 判断是否为遨游浏览器
export function isMaxthon () {
  if (isServer) return false
  let userAgent = navigator.userAgent
  let match = userAgent.match(/Maxthon\/(.+)$/)
  if (match && match.length > 0) return `遨游/${match[1]}`
  return false
}

// 判断是否为世界之窗浏览器
export function isTheWorld () {
  if (isServer) return false
  let userAgent = navigator.userAgent
  let match = userAgent.match(/The World/)
  if (match) return '世界之窗'
  return false
}

export function getUserAgent () {
  if (isServer) return false
  // 判断是否为搜狗
  let sougou = isSougou()
  if (sougou) return sougou
  let liumang = is360()
  if (liumang) return liumang
  // 判断是否为QQ
  let qq = isQQ()
  if (qq) return qq
  // 判断是否为百度
  let baidu = isBaidu()
  if (baidu) return baidu
  // 判断是否为遨游
  let maxthon = isMaxthon()
  if (maxthon) return maxthon
  // 判断是否为UC
  let uc = isUC()
  if (uc) return uc
  // 判断是否为世界之窗浏览器
  let theWorld = isTheWorld()
  if (theWorld) return theWorld
  // 判断是否为Opera浏览器
  let opera = isOpera()
  if (opera) return opera
  // 判断是否为IE浏览器
  let ie = isIE()
  if (ie) return ie
  // 判断是否为谷歌浏览器
  let chrome = isChrome()
  if (chrome) return chrome
  // 判断是否为火狐浏览器
  let firefox = isFirefox()
  if (firefox) return firefox
  // 判断是否Safari浏览器
  let safari = isSafari()
  if (safari) return safari
  return false
}



// WEBPACK FOOTER //
// ./src/utils/user-agent.js